import React, {Component} from 'react';
import Products from './Products';
import Loader from 'react-loader';

class SearchResults extends Component {
  constructor(props) {
    super(props);

    this.state = {
      results: [],
      grabbedSearch: '',
      resultMessage: '',
      loadedProducts: 0,
    };
  }

  componentDidUpdate() {
    this.grabSearchResults();
  }

  componentDidMount() {
    this.grabSearchResults();
  }

  grabSearchQuery() {
    let url = window.location.href;
    return decodeURI(url.slice(url.lastIndexOf('/') + 1));
  }

  createAsyncCollectionCalls(client, collection) {
    return new Promise(function(resolve, reject) {
      client.collection
        .fetchWithProducts(collection)
        .then(res => {
          return resolve(res);
        })
        .catch(err => {
          console.log(err);
          return reject(err);
        });
    });
  }

  removeDuplicates(products) {
    let filteredDuplicates = {};
    for (let i = 0, len = products.length; i < len; i++) {
      filteredDuplicates[products[i].id] = products[i];
    }
    products = [];
    for (let key in filteredDuplicates) {
      products.push(filteredDuplicates[key]);
    }
    return products;
  }

  /*
   *	Grab results from customer's search.
   *	grabSearchResult is called in componentDidUpdate
   *   to avoid inifite loop because of setState
   *   when called in componentDidUpdate
   *   Add a condition to only update state when necessary
   */
  grabSearchResults() {
    let search = this.grabSearchQuery();

    //Customer can enter search result page via url or search
    //check if the search is similar to previous search
    //If yes, do not grab results and return
    if (
      (search && search === this.state.grabbedSearch) ||
      !this.props.match ||
      this.props.match.params.handle === this.state.grabbedSearch ||
      this.props.collections.length === 0 ||
      this.state.loadedProducts === false
    ) {
      return;
    }
    //Needed to reset loadedProducts so Loader shows
    this.setState({loadedProducts: false});

    //Create array of requestAsyncs to pass into Promise
    var a = this.props.collections
      .filter(c => {
        if (c['shopify_collection_id'] != null) {
          return c;
        }
      })
      .map(c => {
        return this.createAsyncCollectionCalls(this.props.client, c.id);
      });
    //Wait for all async requests to respond before updating page
    Promise.all(a).then(
      function(allData) {
        // All async data available here in the order it was called.
        let search = this.grabSearchQuery();
        let resultMessage = '';
        if (!search.length) {
          search = this.props.match.params.handle;
        }
        let products = [];

        //For each collection
        allData.forEach(collection => {
          //Grabs all products in collection
          //Filter out based on search keywords
          let filtered_products = collection.products.filter(product => {
            let keywordList = search.split(' ');
            for (var key in keywordList) {
              var keyword = keywordList[key];
              if (product.title.search(new RegExp(keyword, 'i')) === -1) {
                return false;
              }
            }
            return true;
          });
          products = products.concat(filtered_products);
        });

        resultMessage = !products.length ? 'No Results Found' : '';

        //Get rid of product duplicates if product is found in multiple
        //collections
        products = this.removeDuplicates(products)

        //Update state
        this.setState({
          results: products,
          grabbedSearch: search,
          resultMessage: resultMessage,
          loadedProducts: true,
        });
      }.bind(this),
    );
  }

  render() {
    let showSkeleton = <div />;
    let skeletonList = [];
    for (let i = 0; i < 6; i++) {
      skeletonList.push(
        <div className="col-md-12 col-lg-6 col-xl-4">
          <div className="Product Product__cont">
            <img src="https://dummyimage.com/314x450/eeeeee/fff.png&text=+" />
          </div>
        </div>,
      );
    }

    if (!this.state.loadedProducts) {
      showSkeleton = <div className="row">{skeletonList}</div>;
    }

    let body = (
      <Products
        products={this.state.results}
        addVariantToCart={this.props.addVariantToCart}
        style={this.props.style}
      />
    );

    if (this.state.resultMessage === 'No Results Found') {
      body = (
        <div className="Product-wrapper Search__no-results-found">
          <h1 style={{color: this.props.style.theme}}>
            {this.state.resultMessage}
          </h1>
        </div>
      );
    }

    var showFiller = <div id="temp_filler" />;
    if (this.state.loadedProducts) {
      showFiller = <div />;
    }

    return (
      <div>
        {showSkeleton}
        <Loader loaded={this.state.loadedProducts}>{body}</Loader>
      </div>
    );
  }
}

export default SearchResults;



// WEBPACK FOOTER //
// ./src/components/SearchResults.js